import { createFileRoute } from "@tanstack/react-router";
import { storeListQuery } from "@/api/queries/stores";
import type { StoreListSort } from "@/api/queries/qk";
import { StoresPage, type StoresSearch } from "@/pages/marketplace/StoresPage";

const SORTS: StoreListSort[] = ["featured", "rating", "products", "followers"];

function parseSearch(search: Record<string, unknown>): StoresSearch {
  const sort =
    typeof search.sort === "string" && SORTS.includes(search.sort as StoreListSort)
      ? (search.sort as StoreListSort)
      : "featured";
  const pageValue = typeof search.page === "number" ? search.page : Number(search.page);
  return { sort, page: Number.isInteger(pageValue) && pageValue > 0 ? pageValue : 1 };
}

// The trailing `_` keeps this out of `/marketplace`'s route, so the page does not
// inherit the catalog's search schema — it lists stores, not products.
export const Route = createFileRoute("/_app/marketplace_/stores")({
  validateSearch: parseSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(storeListQuery({ sort: deps.sort, page: deps.page, pageSize: 24 })),
  component: StoresPage,
});
